// Custom constants based on company id (The key of each constant is the company id)
export const CUSTOM_CONSTANTS = {
    PHONE_PATTERN: {
        25: /^([0\u0660][0-9\u0660-\u0669]{3}[ -]?[0-9\u0660-\u0669]{3}[ -]?[0-9\u0660-\u0669]{2,3}|[1\u0661][0-9\u0660-\u0669]{3}[ -]?[0-9\u0660-\u0669]{3}[ -]?[0-9\u0660-\u0669]{3})$/,
        251: /^((\((0{2}|\+)?(966)\)|(0{2}|\+)?(966))[ -]?[15][0-9]{8}|((?!(966|(0{2}|\+)966))0?[15][0-9]{8}))|(((\((0{2}|\+)?(966)\)|(0{2}|\+)?(966))[ -]?(((920)[0-9]{6})|((800)[0-9]{7})))|((?!(966|(0{2}|\+)966))(((920)[0-9]{6})|((800)[0-9]{7}))))$/,
        209: /^((\((0{2}|\+)?(966)\)|(0{2}|\+)?(966))[ -]?[15][0-9]{8}|((?!(966|(0{2}|\+)966))0?[15][0-9]{8}))|(((\((0{2}|\+)?(966)\)|(0{2}|\+)?(966))[ -]?(((920)[0-9]{6})|((800)[0-9]{7})))|((?!(966|(0{2}|\+)966))(((920)[0-9]{6})|((800)[0-9]{7}))))$/,

    }
};
